const PORTFOLIO_RETURN_SESSION_KEY = 'black_peak_portfolio_return_session';

const createSessionId = () => {
  if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') {
    return crypto.randomUUID();
  }

  return `${Date.now()}-${Math.random().toString(36).slice(2)}`;
};

export function getPortfolioReturnSessionId() {
  const existingSessionId = sessionStorage.getItem(PORTFOLIO_RETURN_SESSION_KEY);
  if (existingSessionId) {
    return existingSessionId;
  }

  const sessionId = createSessionId();
  sessionStorage.setItem(PORTFOLIO_RETURN_SESSION_KEY, sessionId);
  return sessionId;
}

export function clearPortfolioReturnSessionId() {
  sessionStorage.removeItem(PORTFOLIO_RETURN_SESSION_KEY);
}
